import React, { useContext, useState } from 'react';
import classnames from 'classnames';

import Context from "../context/context";
import NavItemMobile from './NavItemMobile';
import TopFilter from './TopFilter';
import Search from './Search';
import HiddenSearch from './HiddenSearch';


const FilterNavMobile = props => {
  const {topFilter, clearAllFilters} = props;
  const {topMobileMenu, setTopMobileMenu, mobileMenu, setMobileMenu, language,activeFilters, filterNav, setFilterNav,currentY, setCurrentY,initialY, setInitialY, yOffset, setYOffset,dragStyle, setDragStyle,navStatus, setNavStatus} = useContext(Context);

  let widgets_open = false;




  let current_top_filter = "All";

  if (typeof activeFilters.top_filter != undefined && activeFilters.top_filter.value){
    let value = activeFilters.top_filter.value;
    let options = activeFilters.top_filter.options;

    options.forEach(option => {
      if (option.value == value){
        current_top_filter = option.name;
      }
    })
  }


  const toggleFilterNav = () => {
    const body = document.querySelector('body');

    if (!mobileMenu && !topMobileMenu){
      body.classList.add('filters-open');
      setMobileMenu(true);

    } else {
      body.classList.remove('filters-open');
      setNavStatus(false);
      setTopMobileMenu(false);
      setMobileMenu(false);
      let updatedFilterNav = [...filterNav]
      updatedFilterNav.map((nav, i) => {
        nav.open = false;
      })
      setFilterNav(updatedFilterNav)
    }




  }

  const toggleMobileMenu = () => {
    const body = document.querySelector('body');

    setTopMobileMenu(false);
    if (mobileMenu){
      setMobileMenu(false);
      body.classList.remove('filters-open');

    } else {
      setMobileMenu(true);
      body.classList.add('filters-open');

    }

    setNavStatus(false);
    let updatedFilterNav = [...filterNav]
    updatedFilterNav.map((nav, i) => {
      nav.open = false;
    })
    setFilterNav(updatedFilterNav)

  }

  const toggleTopMobileMenu = () => {
    const body = document.querySelector('body');

    setMobileMenu(false);

    if (topMobileMenu){
      setTopMobileMenu(false);
      body.classList.remove('filters-open');
    } else {
      setTopMobileMenu(true);
      body.classList.add('filters-open');
    }

    setNavStatus(false);

    let updatedFilterNav = [...filterNav]
    updatedFilterNav.map((nav, i) => {
      nav.open = false;
    })

    setFilterNav(updatedFilterNav)

  }


  return (
    <>
    <div className={classnames('mobile-filters-container ', {
        active: mobileMenu || topMobileMenu
      })}>

    <div
      className={classnames('mobile-filters ', {
        active: mobileMenu || topMobileMenu
      })}
      >
      <div className="mobile-filters-top">
        <button className="mobile-filters-toggle" onClick={() => toggleFilterNav()}>
        {
          (mobileMenu || topMobileMenu) &&
          <span>Close
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 10 11" fill="none">
            <path d="M1 9.49951L8.99872 1.5008" stroke="black" stroke-width="2" stroke-linecap="round"/>
            <path d="M8.99902 9.49951L1.00031 1.5008" stroke="black" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </span>
        }
        {
          (!mobileMenu && !topMobileMenu) &&
          <span className="sr-only">Open</span>
        }
        </button>
      </div>
      <div className="mobile-filters-inner">
        <button
          className={classnames('mobile-filter-trigger ', {
            active: mobileMenu
          })}
          onClick={() => toggleMobileMenu()}>
            <span className="trigger-title">
            {language.filter_by}
            </span>
        </button>

        {
          (topFilter.options.length > 1) &&

          <button
            className={classnames('mobile-filter-trigger top', {
              active: topMobileMenu
            })}
            onClick={() => toggleTopMobileMenu()}>
            <span class="trigger-title">{language.top_filter_title}</span>
            <span class="trigger-label">{current_top_filter}</span>
          </button>
          }
      </div>

    </div>

        <div
        className={classnames('filter-nav-mobile', {
          active: mobileMenu
        })}>
        <div className="filter-nav-mobile-inner">
          {filterNav.map((widget, i) => {
            if (widget.position != "top" && widget.type != "hidden"){

            return <NavItemMobile
                      key={i}
                      widget={widget}
                   />
             }
          })}

          {filterNav.map((widget, i) => {

            if (widget.position != "top") {
              if (widget.filters[0].type == "search") {
                return <Search key={i} data={widget.filters[0]}/>
              }
              else if (widget.filters[0].type == "hidden") {
                return <HiddenSearch key={i} data={widget.filters[0]} clearAllFilters={clearAllFilters}/>
              }
            }
          })}

          </div>
        </div>
        <div
        className={classnames('filter-nav-mobile top', {
          active: topMobileMenu
        })}>
          <TopFilter />
        </div>



        </div>
    </>
  )
}

export default FilterNavMobile;
